import React from 'react';
import styled from 'styled-components';
import imgGooglePlay from 'src/assets/images/img_googleplay.png';
import imgAppStore from 'src/assets/images/img_app_store.png';
import {Noto_Description1_r14, Noto_Description1_r16, Noto_Description2_r12} from "src/styles/font/NotoSansKrFonts";
import {mediaLaptop, mediaTablet, mediaUnderTablet} from "src/styles/mediaQuery";
import {Link} from "react-router-dom";

const FooterView = () => {
    return (
        <FooterContainer>
            <Inner>
                <Nav>
                    <NavList>
                        <NavItem>
                            <NavLink href='http://www.datauniverse.co.kr' target="_blank">회사소개</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink href="https://bp.eventu.co.kr/ex/terms/302001" target="_blank">이용약관</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink href="https://bp.eventu.co.kr/ex/terms/302006" target="_blank">개인정보처리방침</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink href="https://bp.eventu.co.kr/ex/terms/302014" target="_blank">서비스 이용안내</NavLink>
                        </NavItem>
                    </NavList>
                    <ButtonWrapper>
                        <DownloadButton to={'https://play.google.com/store/apps/details?id=com.datau.eventu'} target="_blank" className="google-play">Google Play</DownloadButton>
                        <DownloadButton to={'https://itunes.apple.com/kr/app/id6602889410'} target="_blank" className="app-store">App Store</DownloadButton>
                    </ButtonWrapper>
                </Nav>
                <InfoWrapper>
                    <Info>
                        <p>주소 : 서울특별시 영등포구 여의대로 70 원센티널 10층</p>
                        <p>제휴&광고 문의 : biz@datau.co.kr</p>
                        <p>고객센터 : help_eventu@datau.co.kr | 1877-7331</p>
                    </Info>
                    <Info>
                        <p>(주)데이터유니버스</p>
                        <p>통신판매업신고 제2020-서울영등포-1315호, 사업자 등록번호 382-86-01230, 대표자 강원석</p>
                        <p>&copy; 2024 DATAUNIVERSE All rights reserved.</p>
                    </Info>
                </InfoWrapper>
                <Advice>
                    일부 상품의 경우 (주)데이터유니버스는 통신판매의 당사자가 아닌 통신판매중개자로서 상품정보 및 거래에 대한 책임이 제한될 수 있으므로, 각 상품 페이지에서 구체적인 내용을 확인하시기 바랍니다.
                </Advice>
            </Inner>
        </FooterContainer>
    );
};

export default FooterView;

// 스타일드 컴포넌트 섹션
const FooterContainer = styled.footer`
  width: 100%;
  padding: 36px 20px 102px;
  margin: 0 auto;
  background-color: var(--black-2);

  ${mediaTablet} {
    padding: 36px 20px 38px;
  }

  ${mediaUnderTablet} {
    padding: 30px 20px;
  }
`;

const Inner = styled.div`
  width: 100%;
  height: auto;
  max-width: 1060px;
  margin: 0 auto;
`;

const Nav = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: 70px;

  ${mediaTablet} {
    flex-flow: column-reverse;
    gap: 20px;
  }
`;

const NavList = styled.ul`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 30px;

  ${mediaTablet} {
    gap: 20px;
  }
`;

const NavItem = styled.li``;

const NavLink = styled.a`
 ${Noto_Description1_r16};
  display: block;
  color: var(--black);

  ${mediaTablet} {
    font-size: 12px;
    letter-spacing: -.05rem;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  gap: 9px;
`;

const DownloadButton = styled(Link)`
  ${Noto_Description1_r14};
  max-width: 150px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 20px;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0);
  border: 1px solid var(--black-10);
  flex-shrink: 0;

  &.google-play::before {
    content: "";
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url(${imgGooglePlay})no-repeat center/cover;
    flex-shrink: 0;
  }

  &.app-store::before {
    content: "";
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url(${imgAppStore})no-repeat center/cover;
    flex-shrink: 0;
  }
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  margin-top: 38px;
  ${mediaTablet} {
    gap: 20px;
    flex-flow: column;
   
  }
`;

const Info = styled.div`
  width: 100%;
  display: grid;
  grid-gap: 8px;
  grid-template-columns: repeat(1, 1fr);

  > p {
    ${Noto_Description1_r14};
    color: var(--black-40);
    letter-spacing: -0.02rem;

    ${mediaTablet} {
      font-size: 12px;
      line-height: 1.4;
    
    }
  }
`;

const Advice = styled.p`
  ${Noto_Description2_r12};
  display: none;
  color: var(--black-40);
  margin-top: 14px;

  ${mediaLaptop} {
    display: block;
  }
`;
